<app-pagewrapper>
  <app-title
    title="Access"
    [description]="loading ? 'loading...' : hasAccess ? 'Checking your video settings' : 'Checking your access'"
  ></app-title>
  <div class="mt-6">
    @if (error) {
      <app-banner title="Staff Validation Error" [description]="error" (dismissclick)="clearError()"></app-banner>
    }
  </div>
</app-pagewrapper>
